<template>
</template>
<script>
export default {
  data() {
    return {
     
    }
  },
  created() {
    localStorage.clear();
    const {acticityId} =this.$route.params
    if(!acticityId){
      this.$router.replace({
        name: 'errPage',
        query:{
          tipStr:'未找到活动'
        }
      })
      return
    }
    let query = this.$route.query
    localStorage.setItem("wxLoginData", JSON.stringify({
      sign:query.sign||"",
      data:query.data||"",
    }));
    this.$router.replace({
      name: 'activityInfo',
      params:{
        acticityId
      }
    })
  },
  methods: {

  }
}
</script>


// WEBPACK FOOTER //
// src/views/login/login.vue